


























































































  import { IEmployee } from '@/interfaces';
  import { http } from '@/services';
  import AddEmployeeDialog from '@/views/employees/add-employee.component.vue';
  import { Component, Vue } from 'vue-property-decorator';

  @Component({
  components: {
    AddEmployeeDialog,
  },
})
export default class EmployeesHome extends Vue {
  protected showDialog: boolean = false;
  protected employees: Array<IEmployee> = [];
  protected breadcrumbItems: Array<any> = [
    { text: 'Empresas', exact: true, to: '/empresas', disabled: false },
    { text: 'Colaboradores', disabled: true},
  ];

  protected async mounted(): Promise<void> {
    this.employees.push(...(await http.get(`/companies/${this.$route.params.id}/employees`)).data);
  }

  protected async changeStatus(employeeId: number, employeeStatus: string): Promise<void> {
    if (employeeStatus === 'Ativo') {
      await http.delete(`/companies/${this.$route.params.id}/employees/${employeeId}`);
    } else {
      await http.post(`/companies/${this.$route.params.id}/employees/${employeeId}/reactivate`);
    }
    await this.reload();
  }

  protected async reload(): Promise<void> {
    this.employees.splice(0);
    this.employees.push(...(await http.get(`/companies/${this.$route.params.id}/employees`)).data);
    this.showDialog = true;
  }
}
